export default __webpack_public_path__ + "static/media/deleteIcon3.d9e81056.svg";